<template>
  <Component :is="layout">
    <RouterView />
  </Component>
</template>

<script>

const defaultLayout = 'default'

export default {
  name: 'App',

  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  mounted () {
    if (localStorage.getItem('forward') !== null) {
      const route = localStorage.getItem('forward')
      localStorage.removeItem('forward')
      this.$router.push(route)
    }
  }
};
</script>
